import { msg } from '@lingui/core/macro';
import type { AssessorHistoryStatus } from '@routes/sidebar/admin-center/assessor/___shared___/types.ts';

export const ASSESSOR_QUEUE_DATA_INDEX = {
    DATE: 'date',
    ASSESSEE: 'assessee',
    ATTEMPTS: 'attempts',
    TASK_ELEMENT_TITLE: 'taskElementTitle',
    ASSESSOR: 'assessor',
    ACTION: 'action',
} as const;

export const ASSESSOR_AVAILABLE_ASSESSORS_DATA_SOURCE = 'availableAssessors';

export const ASSESSOR_QUEUE_COLUMN_TITLE = {
    DATE: msg`Date`,
    ASSESSEE: msg`Assessee`,
    ATTEMPTS: msg`Attempts`,
    TASK_ELEMENT_TITLE: msg`Task Element Title`,
    ASSESSOR: msg`Assessor`,
    ACTION: msg`Action`,
} as const;

export const ASSESSOR_SEARCH_FILTERS = {
    IS_EXEMPTION: 'IsExemption',
    STATUS: 'Status',
} as const;

export const ASSESSOR_TAB_DEFAULT_PAGE_SIZE = 10;
export const ASSESSOR_TAB_DEFAULT_PAGE_NUMBER = 1;

export const ASSESSOR_QUEUE_COLUMN_SORT_MAP: Record<string, string> = {
    [ASSESSOR_QUEUE_DATA_INDEX.DATE]: ASSESSOR_QUEUE_DATA_INDEX.DATE,
    [ASSESSOR_QUEUE_DATA_INDEX.ASSESSEE]: ASSESSOR_QUEUE_DATA_INDEX.ASSESSEE,
    [ASSESSOR_QUEUE_DATA_INDEX.ATTEMPTS]: ASSESSOR_QUEUE_DATA_INDEX.ATTEMPTS,
    [ASSESSOR_QUEUE_DATA_INDEX.TASK_ELEMENT_TITLE]: ASSESSOR_QUEUE_DATA_INDEX.TASK_ELEMENT_TITLE,
    [ASSESSOR_QUEUE_DATA_INDEX.ASSESSOR]: ASSESSOR_QUEUE_DATA_INDEX.ASSESSOR,
};

export const ASSESSOR_TASK_ACTION = {
    StartEvaluation: 'StartEvaluation',
    SaveDraft: 'SaveDraft',
    Close: 'Close',
    RequestRedo: 'RequestRedo',
    GrantExemption: 'GrantExemption',
    RejectExemption: 'RejectExemption',
    ChangeAssessor: 'ChangeAssessor',
} as const;

export const HISTORY_STATUS = {
    CLOSED: 'Closed',
    REDO: 'Redo',
    EXEMPTED: 'Exempted',
    EXEMPTION_REJECTED: 'Exemption rejected',
} as const;

export const HISTORY_API_STATUS = {
    CLOSED: 'Closed',
    REDO_REQUIRED: 'RedoRequired',
    EXEMPTION_GRANTED: 'ExemptionGranted',
    EXEMPTION_REJECTED: 'ExemptionRejected',
} as const;

export const HISTORY_FILTER_STATUS_TO_API: Record<string, string> = {
    [HISTORY_STATUS.CLOSED]: HISTORY_API_STATUS.CLOSED,
    [HISTORY_STATUS.REDO]: HISTORY_API_STATUS.REDO_REQUIRED,
    [HISTORY_STATUS.EXEMPTED]: HISTORY_API_STATUS.EXEMPTION_GRANTED,
    [HISTORY_STATUS.EXEMPTION_REJECTED]: HISTORY_API_STATUS.EXEMPTION_REJECTED,
};

export const HISTORY_API_STATUS_TO_UI_DISPLAY: Record<string, AssessorHistoryStatus> = {
    [HISTORY_API_STATUS.CLOSED]: HISTORY_STATUS.CLOSED,
    [HISTORY_API_STATUS.REDO_REQUIRED]: HISTORY_STATUS.REDO,
    [HISTORY_API_STATUS.EXEMPTION_GRANTED]: HISTORY_STATUS.EXEMPTED,
    [HISTORY_API_STATUS.EXEMPTION_REJECTED]: HISTORY_STATUS.EXEMPTION_REJECTED,
};

export const HISTORY_DECISION_TO_UI_DISPLAY = {
    Closed: HISTORY_STATUS.CLOSED,
    RedoRequired: HISTORY_STATUS.REDO,
    ExemptionGranted: HISTORY_STATUS.EXEMPTED,
    ExemptionRejected: HISTORY_STATUS.EXEMPTION_REJECTED,
} as const;
